<div>
  <h4>Export</h4>
  <br/>
  <div class="row">
    <div class="col-2">
      <h6>Start Date</h6>
      <p-datepicker
        [style]="{'width': '100%'}"
        name="filterStartDate"
        class="calendar-picker"
        [placeholder]="'Start Date'"
        [(ngModel)]="filterStartDate"
        [inputStyle]="{'width':'100%'}"
        [maxDate]="filterEndDate"
        oninput="validity.valid||(value='');"
        [showButtonBar]="true"
        >
      </p-datepicker>
    </div>
    <div class="col-2">
      <h6>End Date</h6>
      <p-datepicker
        [style]="{'width': '100%'}"
        name="filterEndDate"
        class="calendar-picker"
        [placeholder]="'End Date'"
        [(ngModel)]="filterEndDate"
        [inputStyle]="{'width':'100%'}"
        [minDate]="filterStartDate"
        oninput="validity.valid||(value='');"
        [showButtonBar]="true"
        >
      </p-datepicker>
    </div>
  </div>
  <hr/>
  @if (isLoading) {
    <span style="margin-left:8px">
      <i class="pi pi-spin pi-spinner" style="font-size: 3.5em"></i>
    </span>
  }
  @for (export of exports; track export) {
    <div style="margin-bottom: 10px;">
      <app-export-row [export]="export" [filterStartDate]="filterStartDate" [filterEndDate]="filterEndDate"></app-export-row>
    </div>
  }
</div>